import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';

export function DebugMobile() {
  return (
    <div className="center flex-col gap-8 height-100">
      <p className="h5 mb-16">Mobile devices do not support remote debug</p>

      <LinkButton variant="secondary" to=".." relative="path">
        Host details
      </LinkButton>
    </div>
  );
}
